import type { ReactNode } from 'react';

export type WordToken = { kind: 'word'; text: string; bold: boolean } | { kind: 'newline' };

const INLINE_MARKDOWN_RE = /(\*\*[^*]+\*\*|\n)/;

export function parseToWordTokens(text: string): WordToken[] {
    const tokens: WordToken[] = [];
    for (const part of text.split(INLINE_MARKDOWN_RE)) {
        if (part === '\n') {
            tokens.push({ kind: 'newline' });
        } else if (part.startsWith('**') && part.endsWith('**')) {
            part.slice(2, -2)
                .split(' ')
                .filter(Boolean)
                .forEach((w) => tokens.push({ kind: 'word', text: w, bold: true }));
        } else {
            part.split(' ')
                .filter(Boolean)
                .forEach((w) => tokens.push({ kind: 'word', text: w, bold: false }));
        }
    }
    return tokens;
}

export function renderInlineMarkdown(text: string): ReactNode[] {
    return text.split(INLINE_MARKDOWN_RE).map((part, i) => {
        if (part === '\n') return <br key={i} />;
        if (part.startsWith('**') && part.endsWith('**'))
            return <strong key={i}>{part.slice(2, -2)}</strong>;
        return part;
    });
}

export function stripMarkdown(text: string): string {
    return text.replace(/\*\*([^*]+)\*\*/g, '$1');
}
